<template>
    <div>
        <div class="h-30 py-6 desktop:h-40  px-6 tablet:px-24 mt-0 bg-gradient-teal space-y-3">
            <div class="font-bold text-lg tablet:text-5xl">ACTIVATE WIFI YOUR WAY</div>
            <div class="text-sm tablet:text-lg tablet:font-bold">One final step to get your new WiFi Network set up</div>
        </div>
        <div class="px-6
                    tablet:px-24
                    py-12
                    max-w-3xl
                    space-y-6">

            <!-- Bad request -->
            <div v-if="submitStatus === 'ACCOUNT-NOT-FOUND'"
                class="rounded-md
                    bg-red-200
                    p-4">
                <div class="flex">
                    <div class="flex-shrink-0">
                        <!-- Heroicon name: solid/x-circle -->
                        <svg
                            class="h-5 w-5 text-red-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true">
                            <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8
                                0 000 16zM8.707 7.293a1 1 0
                                00-1.414 1.414L8.586 10l-1.293
                                1.293a1 1 0 101.414 1.414L10
                                11.414l1.293 1.293a1 1 0
                                001.414-1.414L11.414 10l1.293-1.293a1 1
                                0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="ml-3">
                        <h3 class="text-sm
                                font-medium
                                text-red-900">
                            Activation Failed
                        </h3>
                        <div class="mt-2
                                    text-sm
                                    text-red-800">
                            <p>
                                Your submitted last name and/or serial number does not match our
                                records. Please try again. If you need further assistance, please
                                call 888-536-9600 for assistance.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Unknown error -->
            <div
                v-if="submitStatus === 'UNKNOWN-ERROR'"
                class="rounded-md
                    bg-red-200
                    p-4">
                <div class="flex">
                    <div class="flex-shrink-0">
                        <!-- Heroicon name: solid/x-circle -->
                        <svg
                            class="h-5 w-5 text-red-500"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true">
                            <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16
                                8 8 0 000 16zM8.707 7.293a1
                                1 0 00-1.414 1.414L8.586
                                10l-1.293 1.293a1 1 0 101.414
                                1.414L10 11.414l1.293 1.293a1
                                1 0 001.414-1.414L11.414
                                10l1.293-1.293a1 1 0
                                00-1.414-1.414L10 8.586 8.707
                                7.293z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="ml-3
                                space-y-3">
                        <h3 class="text-sm
                                font-medium
                                text-red-900">
                            Sorry, We could not process your request!
                        </h3>
                        <div class="mt-2
                                    text-sm
                                    text-red-800">
                            <p>
                                We are unable to process your request at this time. Please call
                                our customer service team at (888) 536-9600 for assistance.
                            </p>
                        </div>
                        <button
                            type="button"
                            class="bg-red-50
                                px-2
                                py-1.5
                                rounded-md
                                text-sm
                                font-medium
                                text-red-800
                                hover:bg-red-100
                                focus:outline-none
                                focus:ring-2
                                focus:ring-offset-2
                                focus:ring-offset-red-50
                                focus:ring-red-600">
                            Need to troubleshoot?
                        </button>
                    </div>
                </div>
            </div>

            <!-- Success -->
            <div v-if="submitStatus === 'OK'"
                class="rounded-md
                        bg-green-50
                        p-4">
                <div class="flex">
                    <div class="flex-shrink-0">
                        <svg
                            class="h-5 w-5 text-green-400"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true">
                            <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000
                                16zm3.707-9.293a1 1 0 00-1.414-1.414L9
                                10.586 7.707 9.293a1 1 0 00-1.414 1.414l2
                                2a1 1 0 001.414 0l4-4z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="ml-3">
                        <h3 class="text-sm
                                font-medium
                                text-green-800">
                            Congrats, Your WiFi Pods Have Been Activated!
                        </h3>
                        <div class="mt-2
                                    text-sm
                                    text-green-700">
                            <p>
                                Now check out all the amazing features of WiFi Your Way like
                                Adapt, Control, Guard and Sense. Just open the WiFi Your Way App
                                and see all the connected devices in your home.
                            </p>
                            <br>
                            <p>Rest easy knowing they are all connecting securely!</p>
                        </div>
                    </div>
                </div>
            </div>

            <form
                @submit.prevent="onSubmit()"
                class="space-y-5"
            >
                <h5>To activate your new superpods</h5>
                <div class="text-md
                            tablet:text-lg">
                    Simply enter the Last name associated with your Breezeline
                    account and the SuperPod Serial Number (S/N). The Serial Number is a
                    10-digit alpha-numeric code, found on the back of one of your WiFi Pods.
                </div>
                <div class="space-y-1">
                    <label
                        class="text-sm
                            font-bold"
                        :class="{ 'text-salmon': $v.lastName.$error }">
                        Last Name
                    </label>
                    <input
                        v-model.trim="$v.lastName.$model"
                        type="text"
                        tabindex="1"
                        :class="{ 'border-salmon': $v.lastName.$error }"
                        class="block
                            w-full
                            tablet:w-96
                            sm:text-sm"
                        @keydown.enter.prevent>
                    <div
                        v-if="$v.lastName.$error && !$v.lastName.required"
                        class="text-salmon
                            text-sm">
                        <IconCircleExclamation class="inline mr-1" />
                        Please enter a valid last name
                    </div>
                </div>

                <div class="space-y-1">
                    <label
                        class="text-sm
                            font-bold"
                        :class="{
                            'text-salmon': $v.serialNumber.$error,
                        }">
                        Serial Number
                    </label>
                    <input
                        v-model.trim="$v.serialNumber.$model"
                        type="text"
                        tabindex="1"
                        :class="{ 'border-salmon': $v.serialNumber.$error }"
                        class="block
                            w-full
                            tablet:w-96
                            sm:text-sm"
                        @keydown.enter.prevent>

                    <div
                        v-if="serialNumber.length &&
                            !$v.serialNumber.startsWith &&
                            $v.serialNumber.alphaNum"
                        class="text-salmon
                            text-sm
                            max-w-sm">
                        <IconCircleExclamation class="inline mr-1" />
                        Serial number must start with the number 4, 5 or 6.
                    </div>
                    <div v-if="serialNumber.length && !$v.serialNumber.alphaNum"
                        class="text-salmon
                                text-sm">
                        <IconCircleExclamation class="inline mr-1" />
                        Only alpha numeric values are allowed
                    </div>

                    <div v-if="serialNumber.length &&
                            $v.serialNumber.alphaNum &&
                            !$v.serialNumber.mustBeTenDigits &&
                            $v.serialNumber.startsWith"
                        class="text-salmon
                            text-sm">
                        <IconCircleExclamation class="inline mr-1" />
                        Serial number must be 10 characters long you entered :
                        {{ serialNumber.length }}
                    </div>

                    <div
                        v-if="!$v.serialNumber.required && $v.serialNumber.$error"
                        class="text-salmon text-sm"
                    >
                        <IconCircleExclamation class="inline mr-1" />
                        You Must enter a serial number
                    </div>
                </div>

                <p class="max-w-sm">
                    A SuperPod Serial Number (S/N) can be found on the back of the SuperPod
                    as shown.
                </p>
                <div>
                    <button
                        class="btn btn-primary"
                        type="submit"
                        :disabled="this.submitDisabled"
                    >
                        Activate My WiFi
                    </button>
                </div>
            </form>
        </div>
    </div>

</template>

<script>
    import axios from 'axios'
    import { helpers, required, alphaNum } from 'vuelidate/lib/validators'
    import IconCircleExclamation from "@/atoms/icons/IconCircleExclamation"

    axios.defaults.timeout = 1000 * 10

    const startsWith = helpers.regex('startsWith', /^[4-6]/)
    const mustBeTenDigits = value => value.length === 10
    const apiUrl = window.slbosUrl || 'https://api.breezeline.com'
    const prefix = `${apiUrl}/api/v1`

    export default {
        name: 'ActivateWifi',
        components: {
            IconCircleExclamation,
        },
        metaInfo: {
            title: 'Activate WiFi Your Way Network',
            titleTemplate: '%s  | Breezeline',
            meta: [
                    {
                        name: 'description',
                        content: `Enter your last name and SuperPod serial number to activate and complete your new WiFi Network set up.`
                    }
                 ]
        },
        data () {
            return {
                lastName: '',
                serialNumber: '',
                submitStatus: null,
                submitDisabled: false,
            }
        },
        validations: {
            lastName: {
                required,
            },
            serialNumber: {
                startsWith,
                alphaNum,
                mustBeTenDigits,
                required,
            },
        },
        methods: {
            onSubmit () {
                this.submitDisabled = true;
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.submitDisabled = false;
                    return
                }
                try {
                    this.$store.dispatch('toggleLoading', { value: true }, { root: true })
                    axios
                        .post(`${prefix}/slbos/disable-wifi`, {
                            lastName: this.lastName,
                            SerialNumber: this.serialNumber
                        })
                        .then(res => {
                            if (res.data) {
                                switch (res.data.code) {
                                    case '01':
                                        console.log("passed")
                                        this.submitStatus = 'OK'
                                        break
                                    default:
                                        this.submitStatus = 'UNKNOWN-ERROR'
                                        break
                                 }
                            }
                        })
                        .catch(error => {
                            if (error.response) {
                                switch (error.response.data.code) {
                                case '05':
                                    this.submitStatus = 'ACCOUNT-NOT-FOUND'
                                    break
                                case '09':
                                    this.submitStatus = 'ACCOUNT-NOT-FOUND'
                                    break
                                default:
                                    this.submitStatus = 'UKNOWN-ERROR'
                                    break
                                }
                            } else {
                                this.$store.dispatch('togglePopup', {
                                    type: 'ORDER_MY_REMOTE/ERRORS/OFFLINE',
                                })
                            }
                        })
                        .finally(() => {
                            this.$store.dispatch(
                                'toggleLoading',
                                { value: false },
                                { root: true }
                            )
                        })
                } catch (error) {
                    this.submitDisabled = false;
                    this.$store.dispatch('togglePopup', {
                        type: 'ORDER_MY_REMOTE/ERRORS/OFFLINE',
                    })
                }
            }
        },
    }
</script>
